<template>
<div class="container-fluid bg-white">
	<toolbar>
		<h2>
			<i class="fa fa-cubes"></i>
			Projects Apps
		</h2>

		<projects-toolbar-controls 
			:mobile-breakpoint="800">
		</projects-toolbar-controls>
	</toolbar>

	<addon-app-tab ui-location="Projects Module"></addon-app-tab>
</div>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import ProjectsToolbarControls from "@/pages/project/ProjectsToolbarControls"
import AddonAppTab from "@/components/AddonAppTab"

export default {
	name: "ProjectsApps",
	components: {
		Toolbar,
		AddonAppTab,
		ProjectsToolbarControls
	}
}
</script>